import { contract_tab, info_tab, versioning_tab } from '../../../../../../views/contract/agreement';

export default {
  title: 'Contract details',
  tabs: {
    [info_tab]: 'Info',
    [contract_tab]: 'Contract',
    [versioning_tab]: 'Versioning',
  },
  sections: {
    price_info: 'Price info',
    contact: 'Current contract',
    signature_history: 'Signature history',
  },
  labels: {
    not_signed: 'Contract was not signed yet',
  },
  modals: {
    preview_contract: {
      title: 'Preview contract',
    },
    switch_to_annual: {
      title: 'Switch to annual',
    },
  },
  buttons: {
    save: 'Save',
    preview_and_sign: 'Preview and sign',
    download: 'Download',
    switch_to_annual: 'Switch to annual',
  },
  toasts: {
    failed_to_load_data: 'Failed to load data',
    failed_to_save_changes: 'Failed to save changes',
    changes_got_saved: 'Changes got saved',
  },
};
